/*
 * Copyright (c) 2006 Greenwood Mapping, Inc.
 * ol3 version Nov 8, 2016
 * ol5/es6 version July, 2018
 * Might be room for some optimization by first converting point to LL
 *    so that transformation only has to happen once
 */

import {CSCS} from  '../cscs/src/index.js'
import dd2dms from './util/dd2dms.js'

// Constructor
export default function(config) {

  const mapSRID = config.mapCoordSys || config.olProjection.code;
  const mapCS = new CSCS.CS(CSCS.list[mapSRID.replace(':', '')]);
  const dataCS = (typeof config.dataCoordSys !== 'undefined') ?
    new CSCS.CS(CSCS.list[config.dataCoordSys.replace(':', '')]) : // use config.dataCoordSys if defined, else mapCS
    mapCS;
  var ll = new CSCS.CS(); // defaults to long/lat
  var sp = config.statePlane ? new CSCS.CS(CSCS.list[config.statePlane.replace(':', '')]) : null;
  // var utm = config.utm_zone ? new CSCS.CS(CSCS.list['EPSG269' + config.utm_zone]) : null;
  var utm = config.utm_zone ? new CSCS.CS(CSCS.utm.zone(config.utm_zone)) : null;

  var element;
  const spElement = document.getElementById('coords') && sp ? document.getElementById('coords') : null;
  const llElement = document.getElementById('coordsLL') && ll ? document.getElementById('coordsLL') : null;
  const utmElement = document.getElementById('coordsUTM') && utm ? document.getElementById('coordsUTM') : null;
  var cartesian;  // best available cartesian coord system, used for distance calculations

  if (sp) {
    cartesian = sp;
  } else if (utm) {
    cartesian = utm;
  } else {
    cartesian = null;
  }
  if (cartesian && !cartesian.to_meter) { // utm systems don't define to_meter,
    cartesian.to_meter = 1;               // but we depend on it in Measure.js
  }

  /* // 2024-03-26 don't appear to have these anymore
  element = document.getElementById('coords_label');
  if (element && sp) {
    element.innerHTML = sp.title;
  }
  element = document.getElementById('coords');
  if (element && sp) {
    element.title = sp.title;  // this creates a mouse-over tooltip
  }
  */
  element = document.getElementById('coordsUTM_label');
  if (element && utm) {
    element.innerHTML = utm.title;
  }

  /* *** Private functions *** */


  function display(evt) {
    if (evt.dragging) return
    let x = evt.coordinate[0]
    let y = evt.coordinate[1]
    let p

    if (spElement) {      // display state plane coords
      p = new CSCS.PT(x, y);
      CSCS.transform(mapCS, sp, p);
      spElement.innerHTML = `N:&nbsp;${Math.round(p.y)},&nbsp;E:&nbsp;${Math.round(p.x)}`;
    }

    if (llElement && llElement.offsetParent) {      // display long/lat
      p = new CSCS.PT(x, y);
      CSCS.transform(mapCS, ll, p);
      llElement.innerHTML = `
        <table cellpadding="0" cellspacing="0">
          <tr><td>Lon:&nbsp;${dd2dms(p.x)}</td><td>&nbsp;Lat:&nbsp;${dd2dms(p.y)}</td></tr>
          <tr><td>Lon:&nbsp;${p.x.toFixed(5)}°</td><td>&nbsp;Lat:&nbsp;${p.y.toFixed(5)}°</td></tr>
        </table>`;
    }

    if (utmElement && utmElement.offsetParent) {     // display UTM
      p = new CSCS.PT(x, y);
      CSCS.transform(mapCS, utm, p);
      utmElement.innerHTML = 'X: ' + Math.round(p.x) + ' Y: ' + Math.round(p.y);
    }
  }

  function transform(src, dest, pt, keep) {
    let p;
    if (!(pt instanceof CSCS.PT)) {
      p = new CSCS.PT(pt);
    } else {
      p = pt;
    }
    return CSCS.transform(this[src], this[dest], p, keep);
  }

  return {
    ll: ll, // defaults to long/lat
    sp: sp,
    utm: utm,
    map: mapCS,  // map.getView().getProjection().getCode()
    // extent: config.olView.extent,
    extent: (config.olView || {}).extent,
    data: dataCS,
    cartesian: cartesian,
    display: display,
    Point: CSCS.PT,
    transform: transform
  };
}
